import { PaginatedPoi } from './../../shared/models/paginated-poi.model';
import { AnyAction } from 'redux';
import { IPOIState, POI_STATE, IPoi } from './poi.model';
import { PoiActionService } from './poi.action';

export function poiReducer(state: IPOIState =  POI_STATE, action: AnyAction): IPOIState {

    function orderArray(array_to_order): Array<IPoi> {
      return array_to_order.sort((a, b) => {
        if (a.views > b.views) {
          return -1;
        }
        if (a.views < b.views) {
          return 1;
        }
        return 0;
      });
    }

    function checker(src_array, language, target): boolean {
      if (src_array !== null) {
        const supp_array = src_array.map(({name}) => name[language]);
        return target.every(v => supp_array.includes(v));
      }
      return true;
    }

    switch (action.type) {

        case PoiActionService.PAGINATED_POI_LIST:
          const paginatedPoi: PaginatedPoi = action.payload;
          return {
            ...state,
            list: paginatedPoi.list,
            filtered: paginatedPoi.list,
            ordered: paginatedPoi.list,
            total: paginatedPoi.total,
            size: paginatedPoi.size,
            page: paginatedPoi.page
          };

        case PoiActionService.POI_LIST:
          const ordered_list = orderArray([...action.payload]);
          return {
            ...state,
            list: action.payload,
            filtered: action.payload,
            ordered: ordered_list
          };

        case PoiActionService.SET_POI_CURRENT:
          return {
            ...state,
              current: action.payload
          };

        case PoiActionService.ADD_OR_UPDATE_POI:
          if (state.list.length !== 0) {
            const updateListIdx = state.list.findIndex(({id}) => id === action.payload.id);
            const updateFilteredIdx = state.filtered.findIndex(({id}) => id === action.payload.id);
            let addOrUpdatePoiList = [];
            let addOrUpdatePoiFilteredList = [];
            if (updateListIdx > -1) {
              addOrUpdatePoiList = state.list.map((elem) => {
                if (action.payload.id === elem.id) {
                  return action.payload;
                } else {
                  return elem;
                }
              });
            } else {
              addOrUpdatePoiList = [...state.list, action.payload];
            }
            if (updateFilteredIdx > -1) {
              addOrUpdatePoiFilteredList = state.filtered.map((elem) => {
                if (action.payload.id === elem.id) {
                  return action.payload;
                } else {
                  return elem;
                }
              });
            } else {
              addOrUpdatePoiFilteredList = [...state.filtered];
            }
            const addOrUpdatePoiOrderedList = orderArray(addOrUpdatePoiList);
            return {
              ...state,
              list: [...addOrUpdatePoiList],
              filtered: [...addOrUpdatePoiFilteredList],
              ordered: [...addOrUpdatePoiOrderedList]
            };
          } else {
            return { ...state };
          }

        case PoiActionService.DELETE_POI:
          const listWODeleted = state.list.filter(poi => poi.id !== action.payload);
          const filteredWODeleted = state.filtered.filter(poi => poi.id !== action.payload);
          const orderedWODeleted = state.ordered.filter(poi => poi.id !== action.payload);
          return {
            ...state,
            list: listWODeleted,
            filtered: filteredWODeleted,
            ordered: orderedWODeleted
          };

        case PoiActionService.RESET_FILTERS:
          return {
            ...state,
            filtered: [...state.list],
          };

        case PoiActionService.SEARCH_POI:
          const search_filter = action.payload[0];
          const theme_filter = action.payload[1];
          const geopos_filter = action.payload[2];
          const language_filter = action.payload[3];
          const filtered_list = [...state.list].filter(poi =>
            (poi.poi_name[language_filter].toLowerCase().includes(search_filter.toLowerCase()) &&
            (checker(poi.themes, language_filter, theme_filter)) &&
            (checker(poi.geopos, language_filter, geopos_filter))));
          return {
            ...state,
            filtered: filtered_list
          };

    }

    return state;
}
